'use strict';

/**
 * Collections for diffrent albums
 *
 * @category   Model
 * @module     collection.album
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoCollection = require('base/Colido.Collection');
var AlbumModel = require('../models/album');

var AlbumsUnusedCollection = ColidoCollection.extend({
    api: '/assets/photobox?type=albums',

    name: 'collection:albums:unused',

    model: AlbumModel,

    /**
     * Returns an array with all selected pictures
     * @return {Array}
     */
    getSelectedImages: function() {
        var images = [];

        this.each(function(model) {
            var pictures = model.get('images');
            _.each(pictures, function(picture, idx) {
                if (model.isImagesSelected(idx)) {
                    images.push(picture);
                }
            }.bind(this));
        }.bind(this));

        return images;
    },

    /**
     * Unselects all selected pictures
     * @return {void}
     */
    unsetSelectedImages: function() {
        this.each(function(model) {
            var pictures = model.get('images');
            _.each(pictures, function(picture, idx) {
                if (model.isImagesSelected(idx)) {
                    model.markImage(idx);
                }
            }.bind(this));
        }.bind(this));
    },
});

module.exports = AlbumsUnusedCollection;